(ns dashboard.components.search.events
  (:require
   [re-frame.core :as rf]
   [dashboard.browser-extension :as browser-extension]))

(defn input-element? [el]
  (some (fn [input-el]
          (instance? input-el el))
        [js/HTMLInputElement js/HTMLTextAreaElement]))

(def search-element-id "repliance-quick-search")

(rf/reg-event-fx
 ::set-search-visible
 (fn [{:keys [db]} [_ visible]]
   (let [active-element (.-activeElement js/document)]
     {:db (cond-> (-> db
                      (assoc-in [:search :visible] visible)
                      (assoc-in [:search :index] -1))
            (and (input-element? active-element)
                 ;; Prevent active element being the search input element itself
                 (not= search-element-id (.-id active-element)))
            (assoc-in [:search :active-element] active-element))
      :dispatch [::browser-extension/send-event {:type :set-search-visible
                                                 :visible visible}]})))
